import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { AccountDomainRoute } from '../../routing'

export class AccountDomainPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <AccountDomainRoute />
            </Fragment>
        )
    }
}
